import React, { useContext, useEffect, useRef, useState } from "react";
import Appbar from "../Appbar";
import Herosection from "../Herosection";
import About from "../About";
import Services from "../Services";
import Footer from "../Footer";
import DataContext from "../Controller";
import Form from "../Form";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

const Landingpage = () => {
  const { formVisibility, saveMemberToDb } = useContext(DataContext);
  const [searchParams] = useSearchParams();
  const payment = searchParams.get("payment");
  const [isLoading, setisLoading] = useState(false);
  const hasRun = useRef(false);
  // Reference for main container
  const mainContainerRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (mainContainerRef.current) {
      mainContainerRef.current.scrollTop = 0; // Scroll to top
    }
  }, []);

  const initializeUserStorage = async () => {
    try {
      if (hasRun.current) return; // Prevent multiple calls
      hasRun.current = true; // Mark function as executed
      if (payment === "true") {
        alert(
          "Thank you for purchasing a wordy gift. Remember to remind your recipient that they will be receiving a WordyGift from you."
        );
        const saveUser = await saveMemberToDb();
        if (!saveUser.message) {
          throw new Error("An error occurred");
        }
        // const saveUserResponse = await saveUser.json();
        window.location.href = "/";
      } else if (payment === "false") {
        toast.error("Payment was not successful", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          theme: "light",
          style: {
            backgroundColor: "#BFDBFE",
            color: "#14B8A6",
          },
          progressStyle: {
            background: "#4CAF50",
          },
        });
      }
    } catch (error) {
      console.error("Error handling payment:", error);
    }
  };

  useEffect(() => {
    if (payment && !isLoading) {
      setisLoading(true);
      initializeUserStorage();
    }
  }, [payment]);

  return (
    <div className="w-full flex flex-col overflow-auto">
      <Appbar />
      {!formVisibility && (
        <main
          ref={mainContainerRef}
          className="flex flex-col mt-[30px] md:mt-[80px]"
        >
          <Herosection />
          <About />
          <Services />
        </main>
      )}

      {formVisibility && (
        <aside className="absolute top-0 left-0 w-full mt-0 md:mt-[200px]">
          <Form />
        </aside>
      )}

      <Footer />
    </div>
  );
};

export default Landingpage;
